export default "__VITE_ASSET__CJXkhOoe__"